import React from 'react';

import { AiChatContainer } from '~/components/AiChat/AiChatContainer/AiChatContainer';
import { ChatInputV2 } from '~/components/AiChat/components/ChatInputV2';
import { ChatTitle } from '~/components/AiChat/components/ChatTitle';
import { useChatController } from '~/components/AiChat/controller/ChatControllerContext';
import { ClaimChatControllerProvider } from '~/components/AiChat/controller/useClaimChatController';
import cn from '~/Utils/cn';

export interface ChatPanelProps {
  className?: string;
  showTitle?: boolean;
}

/** The chat a `ChatControllerProvider` above it supplies: its title, with rename where offered, and the transcript. */
export const ChatPanelView: React.FC<ChatPanelProps> = ({ className, showTitle = true }) => {
  const { title, rename, analytics } = useChatController({ required: true });

  return (
    <div className={cn('flex h-full w-full flex-col items-center overflow-hidden', className)}>
      {showTitle && (
        <div className="mb-24 w-full shrink-0 border-0 border-b border-solid border-azure-200">
          <ChatTitle title={title ?? undefined} chatId={analytics.conversationId} onRename={rename} />
        </div>
      )}
      <AiChatContainer
        className="min-h-0 w-full flex-1"
        showGreetingAsMessage
        inputFieldType="inline"
        renderInput={(props) => (
          <ChatInputV2
            value={props.value}
            onChange={props.onChange}
            onSubmit={props.onSubmit}
            onPromptSubmit={props.onPromptSubmit}
            disabled={props.disabled}
            inputRef={props.inputRef}
          />
        )}
      />
    </div>
  );
};

/** The claim chat (`useChatContext()`). */
export const ChatPanel: React.FC<ChatPanelProps> = (props) => (
  <ClaimChatControllerProvider>
    <ChatPanelView {...props} />
  </ClaimChatControllerProvider>
);
